import { render, staticRenderFns } from "./DialogAccountDetail.vue?vue&type=template&id=0cc2aa1e&scoped=true&"
import script from "./DialogAccountDetail.vue?vue&type=script&lang=js&"
export * from "./DialogAccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2aa1e",
  null
  
)

export default component.exports